import React from 'react';
import cx from 'clsx';
import Lottie from 'lottie-react';

import animation from './preload-animation.json';

import styles from './PreloadAnimation.module.scss';

export type PreloadAnimationProps = {
    fullScreen?: boolean;
};

export const PreloadAnimation: React.FC<PreloadAnimationProps> = ({ fullScreen }) => {
    return (
        <div className={cx(styles.wrapper, { [styles.fullscreen]: fullScreen })}>
            <Lottie animationData={animation} loop className={styles.animation} />
        </div>
    );
};
